import React from "react";
import Dialog from "@material-ui/core/Dialog";
import {Button, DialogTitle} from "@material-ui/core";
import {Values} from "Tools/Values";
import {observable} from "mobx";
import {IAuthStore} from "Stores/Auth/types";
import {inject, observer} from "mobx-react";
import {Disable2FADialogContent} from "./styles";
import OTPInputForm from "@src/Components/Ui/OTPInputForm/OTPInputForm";
import {STDialogActions} from "@src/Components/Ui/STDialog";

interface IProps {
    isOpened: boolean;
    handleClose: () => void;
    handleEnabled: () => void;
    auth?: IAuthStore;
}

@inject("auth")
@observer
export default class Disable2FADialog extends React.Component<IProps> {
    @observable otpCode: string = '';
    @observable isValid: boolean = true;
    @observable isLoading: boolean = false;

    handleOtpChange(code: string) {
        this.otpCode = code;
        if (!this.isValid) {
            this.isValid = true;
        }
    }

    async handleDisable2FA() {
        const isDisabled = await this.props.auth.disable2FA(this.otpCode);

        if (isDisabled) {
            this.props.handleEnabled();
        } else {
            this.isValid = false;
        }
    }

    async handleSubmit() {
        if (this.isLoading) return;

        this.isLoading = true;
        await this.handleDisable2FA();
        this.isLoading = false;
    }

    render() {
        return (
            <Dialog
                maxWidth="sm"
                open={this.props.isOpened}
                onClose={this.props.handleClose}
            >
                <DialogTitle>
                    {Values.getLocalizationValue('disable2FA')}
                </DialogTitle>

                <Disable2FADialogContent>
                    <span style={{width: 400, textAlign: 'center'}}>
                        {Values.getLocalizationValue('enterCodeToDisableTwoFactorAuthLabelContent')}:
                    </span>

                    <OTPInputForm
                        value={this.otpCode}
                        onChange={(code) => this.handleOtpChange(code)}
                        error={!this.isValid}
                        handleSubmit={this.handleSubmit.bind(this)}
                    />
                </Disable2FADialogContent>

                <STDialogActions style={{padding: 16}}>
                    <Button
                        onClick={this.props.handleClose}
                        variant="outlined"
                        color="default"
                    >
                        {Values.getLocalizationValue('cancel')}
                    </Button>

                    <Button
                        onClick={this.handleSubmit.bind(this)}
                        disabled={this.otpCode.length !== 6}
                        variant="contained"
                        color="primary"
                        style={{width: 100}}
                    >
                        {Values.getLocalizationValue('confirm')}
                    </Button>
                </STDialogActions>
            </Dialog>
        )
    };
}
